import { createContext, useContext } from 'react';
import { ScreenThemeStateContextType } from '../ScreenThemeStateProvider/ScreenThemeStateContext';
import { FullEventFragment } from '@/generated/graphql';

export interface AdminScreenThemeStateContextType
  extends ScreenThemeStateContextType {
  event: FullEventFragment;
}

export const adminScreenThemeStateContext =
  createContext<AdminScreenThemeStateContextType | null>(null);

export function useAdminScreenThemeState() {
  const context = useContext(adminScreenThemeStateContext);
  if (!context) {
    throw new Error(
      'useAdminScreenThemeState must be used within AdminScreenThemeStateProvider',
    );
  }
  return context;
}
